import styled from 'styled-components';
import Icon from '../Icon';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: ${props => props.headerHeight};
  background-color: ${props => props.headerBgColor};
  color: ${props => props.headerColor};
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledBackButton = styled(Icon).attrs({
  icon: 'TR5-Arrow_left'
})`
  width: 18px;
  margin-left: 18px;
  cursor: pointer;
`;

export const PageTitle = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  letter-spacing: 1.2px;
  margin-left: 24px;
  text-transform: uppercase;
`;
